import Dropzone  from 'react-dropzone';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import '../css/custom.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { EMAIL_VERIFICATION_TYPE, EREG_VERIFICATION_TYPE, FILE_UPLOAD_LIMIT } from '../components/AppConstants';

function Verify() {
    const params = new URLSearchParams(window.location.search);
    const urlParams = params.get('url');
    const [countryParam, setCountryParam] = useState(() => {
        return params.get('country') || sessionStorage.getItem("country"); 
    });

    const containerStyle = {
        textAlign: "justify",
        padding: "0 20%"
    };

    const [isDocumentValid, setIsDocumentValid] = useState(true);

    useEffect(() => {
        sessionStorage.setItem("country", countryParam);
    }, [countryParam]);

    let jsonFromParams = null;

    let rIdParam;
    if (urlParams) {
        const tempParams = new URL(urlParams);
        rIdParam = tempParams.searchParams.get('rid');
    }
    
    useEffect(() => {
        if (urlParams) {
            fetch(urlParams).then(response => response.json())
                .then(json =>  navigate('/viewer', {state: {document: json, rId: rIdParam, country: countryParam, verificationType: EMAIL_VERIFICATION_TYPE}}));
        }
    }, [])

    const [documentJson, setDocumentJson] = useState(urlParams ? jsonFromParams : null);
    //const [isFirstRender, setIsFirstRender] = useState(true);
    const navigate = useNavigate();

    function onDropFile(acceptedFiles) {
        acceptedFiles.forEach(file => {
            const validated = validateFileUpload(file);
            console.log("File validation: " + validated);

            if (!validated) {
                setIsDocumentValid(validated);
                return;
            }
            const reader = new FileReader();

            reader.onabort = () => console.log("file reading was aborted");
            reader.onerror = () => console.log("file reading has failed");
            reader.onload = () => {
                try {
                    const json = JSON.parse(reader.result);
                    setDocumentJson(json);
                } catch (error) {
                    console.log(error);
                }
            }
            reader.readAsText(file);
        })
    }

    function validateFileUpload(file) {
        if (!file) 
            return false;
        const fileRestriction = FILE_UPLOAD_LIMIT;

        const fileName = file.name;
        const fileSizeinMB = file.size / 1000000;
        const fileExtension = fileName.split('.').pop();

        if (fileName.length > fileRestriction.maxLength)
            return false;
        if (fileSizeinMB > fileRestriction.maxSize)
            return false;
        if (fileRestriction.extension.filter(x => x === fileExtension).length === 0)
            return false;

        return true;
    }

    useEffect(() => {
        //if (isFirstRender) setIsFirstRender(false);
        //if (!isFirstRender) {
        if (documentJson) {
            navigate('/viewer', {state: {document: documentJson, rid: null, country: countryParam, verificationType: EREG_VERIFICATION_TYPE}});
        }
        //}
    },
    // eslint-disable-next-line 
    [documentJson])

    function onVerifyClick() {
        setIsDocumentValid(true);
    }

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data?.document) {
                setDocumentJson(event.data.document);
            }
        };
    
        window.addEventListener("message", handleMessage);
    
        return () => window.removeEventListener("message", handleMessage);
    }, []);
    
    return (<div className='tab-content dottet-panel'>
        
    
        {isDocumentValid ? 
            <div>
                <div className="info"><span><FontAwesomeIcon icon={faCircleExclamation} /></span> This function validates an e-Apostille by checking its authenticity by uploading the e-Apostille (.json)</div>
                <Dropzone onDrop={onDropFile}>
                    {({getRootProps, getInputProps}) => (
                        <div {...getRootProps()}>
                            <input {...getInputProps()}/>
                            <div>
                                <div className="dropzone-icon"></div>
                                <p>Drag and drop e-Apostille (.json/.vc2) here</p>
                                <p className="my-6">Or</p>
                                <Button variant="outline-primary" style={{ textTransform: "none" }}>
                                    Upload e-Apostille (.json/.vc2)
                                </Button>
                            </div>
                        </div>
                    )} 
                </Dropzone>
            </div>
            : 
            <div>
                <div style={containerStyle}>
                    The uploaded document does not meet the required criteria. Please ensure that:
                    <ul>
                        <li>The file size does not exceed the maximum size of 20MB.</li>
                        <li>The file name does not exceed 100 characters</li>
                        <li>The file extension is .json</li>
                    </ul>
                    Kindly review and upload a document that meets these specifications.
                </div>
                <br/>
                <Button variant="outline-primary" onClick={onVerifyClick} style={{textAlign: "center", textTransform: "none" }}>Try Another e-Apostille (.json)</Button>  
            </div>
            }
        </div>
    );
};
  
export default Verify;